import React from 'react';
export function AnalyticsPage() {
  return <div className="p-6" data-id="element-79">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-80">
        Analytics
      </h1>
      <div className="text-gray-600 dark:text-gray-400" data-id="element-81">
        Analytics dashboard coming soon...
      </div>
    </div>;
}